/**
 * Email section sub-navigation.
 *
 * Shared across all Email pages (Compose, History, Subscribers, Groups,
 * Suppressions). Replaces the loose cluster of <a className="btn">
 * buttons each page used to render in its header — consistent
 * navigation, less visual noise, clear active state.
 *
 * Groups tab is Pro-only client-side (the server enforces too).
 */
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './EmailNav.css';

interface Tab {
  to: string;
  label: string;
  proOnly?: boolean;
}

const TABS: Tab[] = [
  { to: '/email/compose', label: 'Compose' },
  { to: '/email/history', label: 'History' },
  { to: '/email/subscribers', label: 'Subscribers' },
  { to: '/email/groups', label: 'Groups', proOnly: true },
  { to: '/email/suppressions', label: 'Suppressions' },
];

export default function EmailNav() {
  const { plan } = useAuth();
  const isPro = plan === 'pro';
  const location = useLocation();

  return (
    <nav className="email-nav" aria-label="Email sections">
      <div className="email-nav-tabs">
        {TABS.map(tab => {
          if (tab.proOnly && !isPro) return null;
          const isActive = location.pathname === tab.to;
          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={`email-nav-tab ${isActive ? 'active' : ''}`}
            >
              {tab.label}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
